<style lang="scss">
    .yuan{
        width:12px;height: 12px;border-radius: 50%;
        display: inline-block;
        vertical-align: middle;
        margin-right: 10px;
    }

</style>

<template>
    <div class="search-wrap searchb2c">
        <article class="search-main clearfix">
            <div class="pull-left">
                <Button type="primary" @click="handleModal('add')" icon="md-add">{{$t('erp.product.new_add', { defaultValue: '添加' })}}</Button>
            </div>
            <div class="pull-right">
                <Form :label-width="80" inline>
                    <FormItem :label="$t('erp.product.project_name', { defaultValue: '项目名称' })">
                        <Input clearable v-model.trim="formData['CN_name']" />
                    </FormItem>
                     <FormItem :label="$t('erp.product.project_sample_name', { defaultValue: '项目简称' })">
                        <Input clearable v-model.trim="formData['CN_projectUnicode']" />
                    </FormItem>
                    <FormItem :label-width="1">
                        <Button type="primary" @click="update" icon="ios-search">{{$t('global.common.search', { defaultValue: '搜索' })}}</Button>
                        <Button @click="resetdata" icon='md-refresh'>{{$t('global.common.reset', { defaultValue: '重置' })}}</Button>
                        <Button type="dashed" @click="isOpen=!isOpen">{{$t('global.common.btn_more', { defaultValue: '更多查询' })}}<Icon type="ios-arrow-down" class="margin-left-5"></Icon></Button>
                    </FormItem>
                </Form>
            </div>
        </article>
        <transition name='slide-both' >
            <div v-show="isOpen">
                <Form class="search-other" :label-width="110" inline >
                    <FormItem :label="$t('erp.product.project_incharge', { defaultValue: '项目负责人' })">
                        <Input clearable v-model.trim="formData['CN_manager']" />
                    </FormItem>
                    <FormItem :label="$t('global.common.updatedAt', { defaultValue: '更新时间' })" style="width:330px;">
                        <DatePicker type="daterange"
                                    placement="bottom-end"
                                    placeholder="Select date"
                                    style="width:220px;"
                                    ref="amazonTime"
                                    :value="getdate"
                                    @on-change="handleChange"
                        ></DatePicker>
                    </FormItem>
                </Form>
            </div>
        </transition>

    </div>
</template>

<script>
    import { HttpGetLineList,HttpEditLine } from '@/service/products/productline'
    import { mapState,mapGetters } from 'vuex'

    export default {
        data() {
            return {
                isOpen: false,
                formData:{
                EQ_orgId:global.SYSID,
                },
                getdate:[],
            };
        },
        created() {
            this.update();
        },
        computed: {
            ...mapState('boss',['products']),
            ...mapGetters('diction',['getAllProductPerson']),
    },
    methods: {
        handleModal(type,id) {
            this.$parent.handleOperate('',type,id)
        },
        update(type,parms){
            const formdata = { ...this.formData };
            this.$emit('on-update', { search: formdata, page: 1 });
        },
        resetdata(){
            this.formData = {};
            this.getdate = []
            this.$emit('on-update', {
                    search: {
                        ...this.formData
                },
                page: 1
        });
        },
        handleChange(data){
            this.formData.GE_updated = data[0]
            this.formData.LE_updated = data[1]
        },
    },
    };
</script>
